import { useState } from 'react'

import { F0Card, F0Dialog } from '@factorialco/f0-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import rewardImage1 from 'modules/referral_program/lib/assets/reward1.png'
import rewardImage2 from 'modules/referral_program/lib/assets/reward2.png'
import rewardImage3 from 'modules/referral_program/lib/assets/reward3.png'

interface ChooseRewardModalProps {
  open: boolean
  onClose: () => void
  rewardSelected: string | null
  setRewardSelected: (reward: string | null) => void
  setLinkGenerated: (linkGenerated: boolean) => void
}

const ChooseRewardModal: React.FC<ChooseRewardModalProps> = ({
  open,
  onClose,
  rewardSelected,
  setRewardSelected,
  setLinkGenerated,
}) => {
  const [loading, setLoading] = useState(false)

  const handleGenerateLink = () => {
    setTimeout(() => {
      track(trackingEvents.settings.clickGenerateReferralProgramLink, {
        reward_selected: rewardSelected,
      })
      setLinkGenerated(true)
      setLoading(false)

      handleClose()
    }, 2000)
    setLoading(true)
  }

  const handleClose = () => {
    onClose()
  }

  const rewards = [
    {
      id: 'price_1',
      image: rewardImage1,
      title: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_1.title'
      ),
      description: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_1.description'
      ),
    },
    {
      id: 'price_2',
      image: rewardImage2,
      title: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_2.title'
      ),
      description: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_2.description'
      ),
    },
    {
      id: 'price_3',
      image: rewardImage3,
      title: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_3.title'
      ),
      description: i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.items.price_3.description'
      ),
    },
  ]
  return (
    <F0Dialog
      isOpen={open}
      onClose={onClose}
      title={i18n.t(
        'company_settings.general.factorial_referral_program.revamp.reward_modal.title'
      )}
      primaryAction={{
        label: loading
          ? i18n.t(
              'company_settings.general.factorial_referral_program.revamp.reward_modal.button.generating_link'
            )
          : i18n.t(
              'company_settings.general.factorial_referral_program.revamp.reward_modal.button.generate_link'
            ),
        onClick: handleGenerateLink,
        disabled: !rewardSelected || loading,
      }}
      secondaryAction={{
        label: i18n.t(
          'company_settings.general.factorial_referral_program.revamp.reward_modal.button.close'
        ),
        onClick: onClose,
      }}
    >
      <div className="flex flex-col gap-4">
        <div className=" text-f1-foreground-secondary">
          {i18n.t(
            'company_settings.general.factorial_referral_program.revamp.reward_modal.description'
          )}
        </div>
        <div className="flex flex-row gap-2 justify-center">
          {rewards.map((reward) => (
            <F0Card
              key={reward.title}
              image={reward.image}
              title={reward.title}
              description={reward.description}
              onSelect={() => {
                setRewardSelected(reward.id)
              }}
              selectable
              selected={rewardSelected === reward.id}
              onClick={() => {
                setRewardSelected(reward.id)
              }}
            />
          ))}
        </div>
      </div>
    </F0Dialog>
  )
}

export default ChooseRewardModal
